import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, Loader2, ShieldCheck } from "lucide-react";

export default function AdminAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/alerts").then(({ data }) => {
      setAlerts(data.alerts || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-alerts-page">
      <div>
        <div className="label-eyebrow">Missed documentation</div>
        <h1 className="mt-1 text-3xl font-heading font-semibold tracking-tight">Alerts</h1>
        <p className="mt-1 text-sm text-clinical-subtext">
          Clients scheduled today or yesterday with no report submitted.
        </p>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-16 text-clinical-subtext">
          <Loader2 className="h-5 w-5 animate-spin mr-2" /> Loading…
        </div>
      ) : alerts.length === 0 ? (
        <div className="card-surface p-12 text-center">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-600">
            <ShieldCheck className="h-6 w-6" />
          </span>
          <h3 className="mt-4 font-heading text-lg">All clear</h3>
          <p className="mt-1 text-sm text-clinical-subtext">
            Every scheduled visit has been documented.
          </p>
        </div>
      ) : (
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="alerts-list">
          {alerts.map((a, i) => (
            <li
              key={`${a.client_id || a.kind || "alert"}-${a.date || ""}-${i}`}
              className="card-surface p-4 flex items-start gap-3"
              data-testid={`alert-${i}`}
            >
              <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${
                a.severity === "high"
                  ? "bg-destructive/10 text-destructive"
                  : "bg-amber-500/10 text-amber-600"
              }`}>
                <AlertTriangle className="h-5 w-5" />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-medium truncate">{a.client_name}</h3>
                <div className="text-xs text-clinical-subtext mt-0.5">
                  Missed on {a.missed_date} ({a.day}) ·{" "}
                  <span className={a.severity === "high" ? "text-destructive font-medium" : "text-amber-600 font-medium"}>
                    {a.severity === "high" ? "Yesterday" : "Today"}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
